module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/809352dde32b1195a44711f5f5b933c2.png";